import { Injectable } from '@angular/core';
import { FetchPolicy } from '@core/enums/fetch-policy-apollo.enum';
import { Apollo, gql } from 'apollo-angular';
import { Observable, map } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class PostponedOrdersService {
  constructor(private apollo: Apollo) {}

  public getPostponedOrdersCount(): Observable<number> {
    return this.apollo
      .query<{ getPostponedInitialOrdersCount: number }>({
        query: gql`
          query GetPostponedInitialOrdersCount {
            getPostponedInitialOrdersCount
          }
        `,
        fetchPolicy: FetchPolicy.NoCache,
      })
      .pipe(map(({ data }) => data.getPostponedInitialOrdersCount));
  }
}
